import React, { useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  FormGroup,
  Input,
  Label,
  Tooltip,
  Dropdown,
  Badge,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faCheckSquare,
  faSquare,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import _ from "underscore";

const IncrementalData = ({
  datasets,
  datasetsList,
  incrementalDatasets,
  setIncrementalDatasets,
  incrementalDataShow,
  setIncrementalDataShow,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [chosenIncrementalLength, setChosenIncrementalLength] = useState(0);
  const [chosenTitle, setChosenTitle] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [all, setAll] = useState(true);
  const allowMultiIncrementals = false;

  const toggleSelectedField = (field, title) => {
    let newData = incrementalDatasets;

    if (allowMultiIncrementals) {
      if (newData.filter((e) => e === field).length > 0) {
        newData = newData.filter((e) => e !== field);
      } else {
        newData.push(field);
      }
      const newDataFiltered = newData.filter((data) => data.length > 0);

      setIncrementalDatasets(
        newDataFiltered.length === 0 ? [""] : newDataFiltered
      );
      setAll(newDataFiltered.length !== datasets.length);
      setChosenIncrementalLength(newDataFiltered.length);
    } else {
      setIncrementalDatasets([field]);
      setChosenTitle(title);
      setChosenIncrementalLength(1);
    }
  };

  const toggleAllFields = () => {
    setAll(!all);
    if (all) {
      setIncrementalDatasets(datasets);
      setChosenIncrementalLength(datasets.length);
    } else {
      setIncrementalDatasets([""]);
      setChosenIncrementalLength(0);
    }
  };

  useEffect(() => {
    if (incrementalDatasets.length > 0) {
      const remainderIncrementals = [];
      incrementalDatasets.forEach((chosen) => {
        if (_.contains(datasets, chosen)) remainderIncrementals.push(chosen);
      });
      setIncrementalDatasets(
        remainderIncrementals.length === 0 ? [""] : remainderIncrementals
      );
      setChosenIncrementalLength(remainderIncrementals.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datasets]);

  useEffect(() => {
    const filterHolder = incrementalDatasets.filter(
      (dataset) => dataset.length > 0
    );
    if (filterHolder) setChosenIncrementalLength(filterHolder.length);

    if (!allowMultiIncrementals && datasetsList) {
      let itemTitle;
      datasetsList.forEach((e) => {
        if (_.isMatch(e, { id: incrementalDatasets[0] })) itemTitle = e.title;
        return itemTitle;
      });
      setChosenTitle(itemTitle);
    }
  }, [incrementalDatasets, allowMultiIncrementals, datasetsList]);

  useEffect(() => {
    if (!incrementalDataShow) setIncrementalDatasets([""]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incrementalDataShow]);

  return (
    <FormGroup className="builder__incremental">
      <Label check>
        <Input
          className="ms-auto me-2"
          id="allowIncrementalData"
          type="checkbox"
          onClick={() => setIncrementalDataShow(!incrementalDataShow)}
          onKeyPress={() => setIncrementalDataShow(!incrementalDataShow)}
          onChange={() => setIncrementalDataShow(!incrementalDataShow)}
          checked={incrementalDataShow}
        />
        Schedule with Incremental Data
        <FontAwesomeIcon
          className="ms-auto"
          icon={faInfoCircle}
          id="incrementalData"
        />
        <Tooltip
          placement="right"
          target="incrementalData"
          isOpen={tooltipOpen}
          toggle={() => setTooltipOpen(!tooltipOpen)}
          autohide={false}
          innerClassName="longTooltip"
        >
          <>
            If Incremental Data is enabled, the records returned will be new or
            those that have been modified since the previous run of the extract.
            <br />
            <br />
            If disabled, each successive run of the extract will return all
            applicable records each time.
          </>
        </Tooltip>
      </Label>
      <section>
        <p className="builder__block-description">
          {allowMultiIncrementals ? (
            <>Select datasets to return only new or updated records:</>
          ) : (
            <>Select a dataset to return only new or updated records:</>
          )}
        </p>
        <Dropdown
          isOpen={menuOpen}
          toggle={() => setMenuOpen(!menuOpen)}
          disabled={!incrementalDataShow}
          direction="down"
        >
          <DropdownToggle
            id="selectIncrementalData"
            color={incrementalDataShow ? "primary" : "secondary"}
            outline={chosenIncrementalLength === 0 || !incrementalDataShow}
            disabled={!incrementalDataShow}
            caret
          >
            {allowMultiIncrementals ||
            (chosenIncrementalLength === 0 && !chosenTitle) ? (
              <>Incremental Datasets</>
            ) : (
              chosenTitle
            )}
            {chosenIncrementalLength > 0 &&
              allowMultiIncrementals &&
              incrementalDataShow && (
                <Badge color="light" className="ms-2">
                  {chosenIncrementalLength}
                </Badge>
              )}
          </DropdownToggle>
          {allowMultiIncrementals ? (
            <DropdownMenu id="selectIncrementalData-dropCheckMenu">
              {datasets &&
                datasets.map((item) => {
                  const active =
                    incrementalDatasets.filter((e) => e === item).length > 0;
                  let itemTitle = item;
                  if (datasetsList) {
                    datasetsList.forEach((e) => {
                      if (_.isMatch(e, { id: item })) itemTitle = e.title;
                      return itemTitle;
                    });
                  }
                  return (
                    <DropdownItem
                      key={item}
                      toggle={false}
                      onClick={() => {
                        toggleSelectedField(item, itemTitle);
                      }}
                      className="d-flex align-items-center"
                      active={active}
                      value={item}
                    >
                      <FontAwesomeIcon
                        icon={active ? faCheckSquare : faSquare}
                      />
                      <span className="mx-2">{itemTitle}</span>
                    </DropdownItem>
                  );
                })}
              <div className="builder__fields-all">
                <DropdownItem onClick={toggleAllFields} toggle={false}>
                  {all ? "Select all" : "Remove All"}
                </DropdownItem>
              </div>
            </DropdownMenu>
          ) : (
            <DropdownMenu id="selectIncrementalData-dropRadioMenu">
              {datasets &&
                datasets.map((item) => {
                  const active =
                    incrementalDatasets.filter((e) => e === item).length > 0;
                  let itemTitle = item;
                  if (datasetsList) {
                    datasetsList.forEach((e) => {
                      if (_.isMatch(e, { id: item })) itemTitle = e.title;
                      return itemTitle;
                    });
                  }
                  return (
                    <DropdownItem
                      key={item}
                      onClick={() => {
                        toggleSelectedField(item);
                      }}
                      className="d-flex align-items-center"
                      active={active}
                      value={item}
                    >
                      <span className="mx-2">{itemTitle}</span>
                    </DropdownItem>
                  );
                })}
            </DropdownMenu>
          )}
        </Dropdown>
      </section>
    </FormGroup>
  );
};

IncrementalData.propTypes = {
  datasets: PropTypes.array.isRequired,
  datasetsList: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  incrementalDatasets: PropTypes.array.isRequired,
  setIncrementalDatasets: PropTypes.func.isRequired,
  incrementalDataShow: PropTypes.bool.isRequired,
  setIncrementalDataShow: PropTypes.func.isRequired,
};

IncrementalData.defaultProps = {
  datasetsList: null,
};

export default IncrementalData;
